import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a082f71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-wrap col-12" }
const _hoisted_2 = { class: "row flex-wrap align-items-center gy-2 col-12" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-auto" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-dark"
  }, " Login ")
], -1))
const _hoisted_4 = { class: "col-auto" }

import { ElMessage } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";
import { onBeforeMount, onMounted, reactive, ref, Ref } from "vue";
import { ValidateFieldsError } from "async-validator";
import { useAuthStore } from "@/stores/auth";
import { useMiscStore } from "@/stores/misc";
// import { ApiAccountLoginPostRequest } from "@/api-client";
import { useRoute, useRouter } from "vue-router";
import { handleInvalidForm } from "@/utilities/api";
import Spinner from "@/components/spinner/Spinner.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginForm',
  setup(__props) {

const authStore = useAuthStore();
const loginFormRef = ref<FormInstance>();
let formData = reactive<any>({
  email: "",
  password: "",
});
let returnUrl: Ref<string | null> = ref(null);
const route = useRoute();
const router = useRouter();
// let rememberMe: Ref<boolean> = ref(false);

const rules = reactive<FormRules<any>>({
  email: [
    {
      required: true,
      type: "email",
      message: "Please enter a valid email address",
      trigger: "change",
    },
  ],
  password: [
    { required: true, message: "Please enter a password", trigger: "change" },
  ],
});

const miscStore = useMiscStore();
onBeforeMount(() => {
  if (route.query.returnUrl) {
    returnUrl.value = route.query.returnUrl as string;
  }
});
onMounted(() => {
  miscStore.isLoading = false;
});

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      miscStore.isLoading = true;

      await authStore.login(formData)
      .then((res) => {
        miscStore.isLoading = false;
        if(returnUrl.value) {
          router.push({path: `${returnUrl.value}`})
        } else {
          router.push({name: 'Home'})
        }
      })
      .catch((error) => {
        miscStore.isLoading = false;
      })
    } else {
      handleInvalidForm(fields as ValidateFieldsError)
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (submitForm(loginFormRef.value)), ["prevent"])),
    ref_key: "loginFormRef",
    ref: loginFormRef,
    class: "login-form position-relative col-12",
    model: _unref(formData),
    rules: rules,
    size: "large",
    "label-position": "top",
    "require-asterisk-position": "right"
  }, {
    default: _withCtx(() => [
      _createVNode(Spinner, {
        isAbsolute: true,
        visible: _unref(miscStore).isLoading
      }, null, 8, ["visible"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form_item, {
          class: "col-12 mb-3 mb-md-4",
          label: "Username / Email",
          prop: "email"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              name: "email",
              type: "email",
              modelValue: _unref(formData).email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).email) = $event)),
              placeholder: "Enter your username / email (*)"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "col-12 mb-4 mb-md-5",
          label: "Password",
          prop: "password"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(formData).password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).password) = $event)),
              name: "password",
              type: "password",
              placeholder: "Enter your password (*)",
              "show-password": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "w-auto underline-hover",
            to: { name: 'ForgotPassword' }
          }, {
            default: _withCtx(() => [
              _createTextVNode("Forgot your password?")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}
}

})